import { Component } from '@angular/core';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { NgFor, NgIf } from '@angular/common';
import { DatasearchService } from '../../_services/datasearch.service';

@Component({
  selector: 'app-advisory-panel',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, NgFor, NgIf],
  templateUrl: './advisory-panel.component.html',
  styleUrl: './advisory-panel.component.scss'
})
export class AdvisoryPanelComponent {
  transparent = false;
  panelList: any = [];
  head: any[] = [];
  currentPage: string = 'advisory';
  currentUrl: string;

  constructor(private datasearch: DatasearchService) {
    this.currentUrl = window.location.href; // Get the current URL
  }

  getPanelImageUrl(filename: string): string {
    if (!filename) return 'https://www.chemrobotics.com/uploads/gallery/placeholder.png';
    const strFile = filename.toString();
    if (strFile.startsWith('http')) return strFile;

    let cleanPath = strFile.replace(/^\//, '');
    if (!cleanPath.includes('uploads/')) {
      cleanPath = 'uploads/advisory-panels/' + cleanPath;
    }

    const baseUrl = this.datasearch.ApiUrl.replace(/\/$/, '');
    return `${baseUrl}/${cleanPath}`;
  }
  shareViaEmail() {
    const subject = 'Check out this page!';
    const body = `Here is the link: ${this.currentUrl}`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink; // Open the email client
  }

  shareViaSMS() {
    const smsLink = `sms:?body=${encodeURIComponent(this.currentUrl)}`;
    window.location.href = smsLink; // Open SMS app
  }

  shareViaWhatsApp() {
    const text = `Check this out! ${this.currentUrl}`;
    const whatsappLink = `https://wa.me/?text=${encodeURIComponent(text)}`;

    window.open(whatsappLink, '_blank'); // Open WhatsApp share dialog
  }

  shareViaMessenger() {
    const messengerLink = `https://www.messenger.com/share/?link=${encodeURIComponent(this.currentUrl)}`;
    window.open(messengerLink, '_blank'); // Open Messenger share dialog
  }

  shareViaViber() {
    const viberLink = `viber://forward?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(viberLink, '_blank'); // Open Viber share dialog
  }

  shareViaFacebook() {
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentUrl)}`;

    window.open(facebookLink, '_blank'); // Open Facebook share dialog
  }

  shareViaTwitter() {
    const text = `Check this out! ${this.currentUrl}`;
    const twitterLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;

    window.open(twitterLink, '_blank'); // Open Twitter share dialog
  }

  shareViaLinkedIn() {
    const linkedInLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(linkedInLink, '_blank'); // Open LinkedIn share dialog
  }

  shareViaPinterest() {
    const pinterestLink = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(pinterestLink, '_blank'); // Open Pinterest share dialog
  }

  shareViaReddit() {
    const redditLink = `https://www.reddit.com/submit?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(redditLink, '_blank'); // Open Reddit share dialog
  }

  shareViaTumblr() {
    const tumblrLink = `https://www.tumblr.com/share/link?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(tumblrLink, '_blank'); // Open Tumblr share dialog
  }

  shareViaTelegram() {
    const telegramLink = `https://t.me/share/url?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(telegramLink, '_blank'); // Open Telegram share dialog
  }

  shareViaVK() {
    const vkLink = `https://vk.com/share.php?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(vkLink, '_blank'); // Open VK share dialog
  }

  shareViaMix() {
    const mixLink = `https://mix.com/add?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(mixLink, '_blank'); // Open Mix share dialog
  }

  shareViaXing() {
    const xingLink = `https://www.xing.com/app/user?op=share;url=${encodeURIComponent(this.currentUrl)}`;
    window.open(xingLink, '_blank'); // Open Xing share dialog
  }

  shareViaLine() {
    const lineLink = `https://line.me/R/share?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(lineLink, '_blank'); // Open Line share dialog
  }

  copyLink() {
    navigator.clipboard.writeText(this.currentUrl).then(() => {
      alert('Link copied to clipboard!');
    });
  }
  // Add more sharing methods as needed

  ngOnInit() {
    this.getPanelList();
    this.getHeading();
  }

  // getPanelList(){
  //   this.panelList.push({
  //     name: 'Dr. Deepak Lewis',
  //     description: 'Agriculture Research Fellow from Eastern Mediterranean University',
  //     biography: 'Lorem ipsum dolor amet consectet adipiscing do eiusmod tempor incididunt labore dolor magna aliqua ipsum suspen disse ultrices gravida Risus maecenas.',
  //     image: 'person1.png',
  //     education: [
  //       {degree: 'PHD of Agriculture', college: 'in Agriculture Engineering Stanford University', month: 'Mar', year: '2008'},
  //       {degree: 'Masters of Science', college: 'Kusan National University, Busan, South Korea', month: 'May', year: '2010'},
  //       {degree: 'Bachelor of Science', college: 'University of California, Davis, USA', month: 'Sep', year: '2014'},
  //       {degree: 'PHD of Agriculture', college: 'California N. University, California, USA', month: 'Mar', year: '2016'}
  //     ]
  //   });
  //   this.panelList.push({
  //     name: 'Dr. Vishal Lewis',
  //     description: 'Agriculture Research Fellow from Eastern Mediterranean University',
  //     biography: 'Lorem ipsum dolor amet consectet adipiscing do eiusmod tempor incididunt labore dolor magna aliqua ipsum suspen disse ultrices gravida Risus maecenas.',
  //     image: 'person2.png',
  //     education: [
  //       {degree: 'PHD of Agriculture', college: 'in Agriculture Engineering Stanford University', month: 'Mar', year: '2008'},
  //       {degree: 'Masters of Science', college: 'Kusan National University, Busan, South Korea', month: 'May', year: '2010'},
  //       {degree: 'Bachelor of Science', college: 'University of California, Davis, USA', month: 'Sep', year: '2014'},
  //       {degree: 'PHD of Agriculture', college: 'California N. University, California, USA', month: 'Mar', year: '2016'}
  //     ]
  //   });
  // }
  getPanelList() {
    this.datasearch.getAdvisory().subscribe(res => {
      // Filter only active advisory panel members
      this.panelList = res.data.filter((item: any) => item.isActive === true);
    });
  }
  getHeading() {
    this.datasearch.getAllHeadings().subscribe(res => {
      if (res.success) {
        this.head = res.data.filter((heading: any) => heading.page === this.currentPage);
      }
    });
  }
  openLink(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }
}
